import { render } from "./CreateResolution.vue?vue&type=template&id=fe84e98c&scoped=true"
import script from "./CreateResolution.vue?vue&type=script&lang=js"
export * from "./CreateResolution.vue?vue&type=script&lang=js"

import "./CreateResolution.vue?vue&type=style&index=0&id=fe84e98c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe84e98c"]])

export default __exports__